// extracted by mini-css-extract-plugin
module.exports = {"dropdownWeb":"styles_dropdownWeb__6vVmt"};